import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export async function getBrandInfo(object) {
  return request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: '/brand',
    method: 'post',
    data: object,
    // 失敗時由 main.js 決定公開頁降級或導向錯誤頁，不另跳網路錯誤提示蓋住正文
    customConfig: {
      mute: true
    }
  })
}

export async function getQuickBar() {
  return request({
    baseURL: getApiUrl(),
    url: '/brand/quick-bar',
    method: 'post'
  })
}

export async function getMarqueeDetail() {
  return request({
    baseURL: getApiUrl(),
    url: '/brand/marquee-detail',
    method: 'post'
  })
}

export async function getBanner() {
  return request({
    baseURL: getApiUrl(),
    url: '/brand/banner',
    method: 'post',
    data: {
      limit: 11
    }
  })
}

export async function getCarousel(object) {
  return request({
    baseURL: process.env.VUE_APP_BASE_API,
    url: '/brand/carousel',
    method: 'post',
    data: object
  })
}
